<template slot-scope="scope">
  <!-- 切换地址弹窗 -->
  <dialogModel
    title="选择行政区域"
    :visible.sync="dialogAddress"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <!-- 主体 -->
    <div class="main-body">
      <div class="left-menu">
        <div
          v-for="(item, index) in provinceList"
          :key="index"
          :class="[
            item.code == listSelect ? 'left-menu-Select' : '',
            hasProvinceSelection(item.code) ? 'left-menu-has-selected' : '',
          ]"
          @click="handelClickMenu(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="right-Options">
        <!-- 右侧市级box -->
        <div
          class="MunicipalLevel-box"
          :style="TheCity.length == 0 ? 'height:50%' : ''"
        >
          <p
            v-for="(item, index) in TheCity"
            :key="index"
            :class="isCitySelected(item) ? 'TheCitySelect' : ''"
            @click="handelTheCitySelect(item)"
          >
            {{ item.label }}
          </p>
          <p
            v-if="TheCity && TheCity.length && !isNationwideProvinceSelected"
            :class="isAllCitySelected ? 'TheCitySelect' : ''"
            @click="toggleAllCities"
          >
            全选
          </p>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
// 引入接口
import {
  postGetAddressSelect, // 获取地址
  findAddressInfo, //搜索地址
} from "../../../../../assets/api/indexl";
export default {
  props: {
    dialogAddress: {},
    cityCode: {},
    cityName: {},
  },
  components: {},
  data() {
    return {
      input: "", // 搜索框数据

      list: [], // 地址
      listSelect: "", //省级选中
      listSelectName: "",
      TheCity: [], //市级地区
      TheCitySelect: [], //市级多选 code 列表
      TheCitySelectName: [], //市级多选 name 列表
      citySelectionsByProvince: {}, // 按省缓存市级选择
      city: "-",

      options: [],
      value: [],
      listInput: [],
      loading: false, // 加载....
      states: [], //  门类数据列表
    };
  },
  watch: {
    dialogAddress: {
      handler(newSs, old) {
        if (newSs == true) {
          this.syncSelectionFromProps();
        }
      },
      immediate: false,
    },
  },
  computed: {
    showNationwideQuick() {
      return (
        Array.isArray(this.list) &&
        this.list.some(
          (x) =>
            x &&
            (x.label === "全国" || String(x.code) === "001")
        )
      );
    },
    nationwideProvince() {
      return (Array.isArray(this.list) ? this.list : []).find(
        (x) => x && (x.label === "全国" || String(x.code) === "001")
      );
    },
    isNationwideQuickActive() {
      const province = this.nationwideProvince;
      if (!province) return false;
      const children = Array.isArray(province.children) ? province.children : [];
      if (!children.length) return false;
      const saved = this.citySelectionsByProvince[String(province.code)];
      if (!saved || !Array.isArray(saved.codes)) return false;
      return children.every((c) =>
        saved.codes.some((code) => String(code) === String(c.code))
      );
    },
    isAllCitySelected() {
      const cityList = Array.isArray(this.TheCity) ? this.TheCity : [];
      const codes = cityList
        .map((x) => (x ? x.code : ""))
        .filter((x) => x !== undefined && x !== null && String(x) !== "");
      if (!codes.length) return false;
      const selected = Array.isArray(this.TheCitySelect) ? this.TheCitySelect : [];
      return codes.every((c) => selected.some((s) => String(s) === String(c)));
    },
    isNationwideProvinceSelected() {
      const current = (Array.isArray(this.list) ? this.list : []).find(
        (x) => x && String(x.code) === String(this.listSelect)
      );
      return !!(
        current &&
        (current.label === "全国" || String(current.code) === "001")
      );
    },
    provinceList() {
      const source = Array.isArray(this.list) ? this.list : [];
      return source.filter(
        (x) => x && !(x.label === "全国" || String(x.code) === "001")
      );
    },
  },
  async created() {
    // 从Vuex获取地址数据
    const addressList = this.$store.getters.getAddRes;
    if (addressList && addressList.length > 0) {
      this.list = addressList;
    } else {
      await this.postGetAddressSelect();
    }
    // 获取当前城市定位
    this.getCurrentLocation();
  },
  methods: {
    parseCodesFromProps() {
      const raw = this.cityCode;
      if (Array.isArray(raw)) {
        return raw
          .map((x) => String(x).trim())
          .filter((x) => x);
      }
      return String(raw || "")
        .split(",")
        .map((x) => x.trim())
        .filter((x) => x);
    },
    findAddressItemByCityName(cityName) {
      if (!cityName) return null;
      const normalize = (s) => String(s || "").replace(/市$/, "").trim();
      const target = normalize(cityName);
      let provinceMatch = null;
      for (const province of Array.isArray(this.list) ? this.list : []) {
        if (!province) continue;
        const children = Array.isArray(province.children) ? province.children : [];
        for (const city of children) {
          if (!city) continue;
          if (normalize(city.label) === target || city.label === cityName) {
            return city;
          }
        }
        if (normalize(province.label) === target || province.label === cityName) {
          provinceMatch = province;
        }
      }
      return provinceMatch;
    },
    restoreNationwideSelection() {
      const nationwide = this.nationwideProvince;
      if (!nationwide) return;
      this.handelClickMenu(nationwide);
      this.$nextTick(() => {
        const nationwideCities = Array.isArray(nationwide.children)
          ? nationwide.children
          : [];
        this.TheCitySelect = nationwideCities.map((x) => x.code);
        this.TheCitySelectName = nationwideCities.map((x) => x.label);
        this.$set(this.citySelectionsByProvince, String(nationwide.code), {
          codes: this.TheCitySelect.slice(),
          names: this.TheCitySelectName.slice(),
        });
        const provinceList = Array.isArray(this.provinceList) ? this.provinceList : [];
        provinceList.forEach((p) => {
          const children = Array.isArray(p.children) ? p.children : [];
          this.$set(this.citySelectionsByProvince, String(p.code), {
            codes: children.map((x) => x.code),
            names: children.map((x) => x.label),
          });
        });
      });
    },
    restoreSelectionsFromCodes(codes) {
      const provinceList = Array.isArray(this.list) ? this.list : [];
      const newCache = {};

      provinceList.forEach((p) => {
        if (!p || p.label === "全国" || String(p.code) === "001") return;
        const children = Array.isArray(p.children) ? p.children : [];
        let selectedChildren = children.filter((c) =>
          codes.some((code) => String(code) === String(c.code))
        );
        if (
          !selectedChildren.length &&
          codes.some((code) => String(code) === String(p.code))
        ) {
          selectedChildren = children.slice();
        }
        if (selectedChildren.length) {
          newCache[String(p.code)] = {
            codes: selectedChildren.map((x) => x.code),
            names: selectedChildren.map((x) => x.label),
          };
        }
      });

      this.citySelectionsByProvince = newCache;
      const firstProvince = provinceList.find((p) => newCache[String(p.code)]);
      if (firstProvince) {
        this.handelClickMenu(firstProvince);
      }
    },
    syncSelectionFromProps() {
      const codes = this.parseCodesFromProps();
      const name = String(this.cityName || "").trim();

      if (!codes.length && (name === "全国" || name.includes("全国"))) {
        this.restoreNationwideSelection();
        return;
      }
      if (!codes.length) return;

      // 兼容“全国不传001，只传所有省 code”的回显
      const allProvinceCodes = (Array.isArray(this.provinceList) ? this.provinceList : [])
        .map((x) => String(x.code))
        .filter((x) => x);
      const isAllProvinceCodesSelected =
        allProvinceCodes.length > 0 &&
        allProvinceCodes.every((code) => codes.includes(code));
      if (isAllProvinceCodesSelected) {
        this.restoreNationwideSelection();
        return;
      }

      this.restoreSelectionsFromCodes(codes);
    },
    cacheProvinceSelection() {
      if (this.listSelect === undefined || this.listSelect === null || String(this.listSelect) === "") {
        return;
      }
      this.$set(this.citySelectionsByProvince, String(this.listSelect), {
        codes: Array.isArray(this.TheCitySelect) ? this.TheCitySelect.slice() : [],
        names: Array.isArray(this.TheCitySelectName) ? this.TheCitySelectName.slice() : [],
      });
    },
    restoreProvinceSelection(provinceCode, cityList) {
      const saved = this.citySelectionsByProvince[String(provinceCode)];
      if (!saved) {
        this.TheCitySelect = [];
        this.TheCitySelectName = [];
        return;
      }
      const validCodeSet = new Set(
        (Array.isArray(cityList) ? cityList : []).map((x) => String(x.code))
      );
      const restoredCodes = (saved.codes || []).filter((x) =>
        validCodeSet.has(String(x))
      );
      const nameMap = {};
      (Array.isArray(cityList) ? cityList : []).forEach((x) => {
        nameMap[String(x.code)] = x.label;
      });
      this.TheCitySelect = restoredCodes;
      this.TheCitySelectName = restoredCodes.map((x) => nameMap[String(x)] || "");
    },
    hasProvinceSelection(provinceCode) {
      // 选中“全国”且全国下已全选时，左侧所有省都显示为已选状态
      if (
        this.isNationwideProvinceSelected &&
        this.isAllCitySelected &&
        String(provinceCode) !== "001"
      ) {
        return true;
      }
      const saved = this.citySelectionsByProvince[String(provinceCode)];
      return !!(
        saved &&
        Array.isArray(saved.codes) &&
        saved.codes.some((x) => x !== undefined && x !== null && String(x) !== "")
      );
    },
    pickNationwide() {
      const province = this.list.find(
        (x) =>
          x && (x.label === "全国" || String(x.code) === "001")
      );
      if (!province) return;
      const nationwideChildren = Array.isArray(province.children)
        ? province.children
        : [];
      const nationwideSaved = this.citySelectionsByProvince[String(province.code)];
      const isNationwideAllSelected = !!(
        nationwideChildren.length &&
        nationwideSaved &&
        Array.isArray(nationwideSaved.codes) &&
        nationwideChildren.every((c) =>
          nationwideSaved.codes.some((code) => String(code) === String(c.code))
        )
      );

      this.handelClickMenu(province);
      this.$nextTick(() => {
        if (isNationwideAllSelected) {
          // 反选：再次点击全国时，清空全国与各省的选择状态
          this.TheCitySelect = [];
          this.TheCitySelectName = [];
          this.$set(this.citySelectionsByProvince, String(province.code), {
            codes: [],
            names: [],
          });
          const provinceList = Array.isArray(this.provinceList) ? this.provinceList : [];
          provinceList.forEach((p) => {
            this.$set(this.citySelectionsByProvince, String(p.code), {
              codes: [],
              names: [],
            });
          });
          return;
        }

        this.toggleAllCities();
        // 同步把每个省都标记为“已选择”，避免切换省份后显示被取消
        const provinceList = Array.isArray(this.provinceList) ? this.provinceList : [];
        provinceList.forEach((p) => {
          const children = Array.isArray(p.children) ? p.children : [];
          this.$set(this.citySelectionsByProvince, String(p.code), {
            codes: children.map((x) => x.code),
            names: children.map((x) => x.label),
          });
        });
      });
    },
    // 选择 门类名称完毕 获取需要的值
    pestChange(val) {
      this.options = [];
      var arr = val.split("-");
      this.$emit("handleUnderstand", arr[1], [arr[0]]);
      this.input = "";
    },
    // 门类 远程搜索
    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取门类
      var data = {};
      data.data = {
        name: query != "" ? query : "/",
      };
      if (data.data.keyword != "") {
        // 调用 获取门类接口
        await findAddressInfo(data).then((res) => {
          this.states = res.data.list;
          this.listInput = this.states.map((item) => {
            return {
              value: `${item.code}-${item.name}`,
              label: `${item.name}`,
              id: `${item.code}`,
            };
          });
        });
      }
      // 组件 自带远程搜索的函数
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.listInput.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },

    // 从Vuex获取地址数据
    async postGetAddressSelect() {
      this.list = [];
      var arr = this.$store.getters.getAddRes;
      if (arr && arr.length > 0) {
        this.list = Array.isArray(arr) ? arr.slice() : [];
      } else {
        // 如果Vuex中没有数据，调用接口获取
        const res = await postGetAddressSelect();
        if (res && res.code === 0 && res.data) {
          this.list = Array.isArray(res.data) ? res.data : [];
        }
      }
    },
    // 通过百度的接口获取 当前位置
    getCurrentLocation() {
      // 获取当前城市
      const geolocation = new window.BMap.Geolocation();
      geolocation.getCurrentPosition((r) => {
        var str = localStorage.getItem("city");
        if (str != "" && str != null && str != undefined) {
          this.$emit("getGaoDe", str);
        } else {
          this.$emit("getGaoDe", r.address.city);
        }
        var str1 = localStorage.getItem("cityCode");
        if (str1 == "" || str1 == null || str1 == undefined) {
          // 循环拿到当前的定位code
          for (var i in this.list) {
            if (r.address.city == this.list[i].label) {
              localStorage.setItem("cityCode", this.list[i].code);
              return this.$emit("store", [this.list[i].code]);
            }
            for (var k in this.list[i].children) {
              if (r.address.city == this.list[i].children[k].label) {
                localStorage.setItem("cityCode", this.list[i].children[k].code);
                return this.$emit("store", [this.list[i].children[k].code]);
              }
              for (var s in this.list[i].children[k].children) {
                if (r.address.city == this.list[i].children[k].children[s].label) {
                  localStorage.setItem("cityCode", this.list[i].children[k].code);
                  return this.$emit("store", [this.list[i].children[k].code]);
                }
              }
            }
          }
        } else {
          this.$emit("store", [str1]);
        }
      });
    },
    //选择省级
    handelClickMenu(item) {
      // 先缓存上一省的勾选状态
      this.cacheProvinceSelection();
      // 点击省级列表
      // 市级赋值
      this.TheCity = item.children;
      // // 区级赋值
      // this.areaList = item.children[0].children;
      this.areaList = [];
      // 省选中改变
      this.listSelect = item.code;
      this.listSelectName = item.label;
      // 切换省后恢复该省已选择状态
      this.restoreProvinceSelection(item.code, this.TheCity);
      this.areaSelect = "";
      this.areaSelectName = "";
    },
    isCitySelected(item) {
      const selected = Array.isArray(this.TheCitySelect) ? this.TheCitySelect : [];
      return selected.some((x) => String(x) === String(item.code));
    },
    toggleAllCities() {
      const cityList = Array.isArray(this.TheCity) ? this.TheCity : [];
      const codes = cityList.map((x) => x.code);
      const names = cityList.map((x) => x.label);
      if (this.isAllCitySelected) {
        this.TheCitySelect = [];
        this.TheCitySelectName = [];
      } else {
        this.TheCitySelect = codes;
        this.TheCitySelectName = names;
      }
      this.cacheProvinceSelection();
    },
    // 选择 市级
    handelTheCitySelect(item) {
      const selectedCodes = Array.isArray(this.TheCitySelect)
        ? this.TheCitySelect.slice()
        : [];
      const selectedNames = Array.isArray(this.TheCitySelectName)
        ? this.TheCitySelectName.slice()
        : [];

      const idx = selectedCodes.findIndex((x) => String(x) === String(item.code));
      if (idx > -1) {
        selectedCodes.splice(idx, 1);
        selectedNames.splice(idx, 1);
      } else {
        selectedCodes.push(item.code);
        selectedNames.push(item.label);
      }

      this.TheCitySelect = selectedCodes;
      this.TheCitySelectName = selectedNames;
      this.cacheProvinceSelection();
    },

    // 弹窗关闭
    handleClose() {
      // this.listSelect = "";
      // this.listSelectName = "";
      // this.TheCity = [];
      // this.TheCitySelect = "";
      // this.TheCitySelectName = "";
      // this.list = [];
      // this.postGetAddressSelect();
      this.$emit("handleClose");
      //   this.dialogVisible = false;
    },
    // 弹窗确认
    handleUnderstand() {
      this.cacheProvinceSelection();

      if (this.isNationwideQuickActive) {
        this.$emit("handleUnderstand", "全国", []);
        return;
      }

      const provinceList = this.provinceList;
      const emitCodes = [];
      const emitNames = [];

      provinceList.forEach((p) => {
        const saved = this.citySelectionsByProvince[String(p.code)];
        if (!saved || !Array.isArray(saved.codes) || !saved.codes.length) return;

        const children = Array.isArray(p.children) ? p.children : [];
        const allSelected =
          children.length > 0 &&
          children.every((c) =>
            saved.codes.some((sc) => String(sc) === String(c.code))
          );

        if (allSelected) {
          emitCodes.push(p.code);
          emitNames.push(p.label);
        } else {
          saved.codes.forEach((code, idx) => {
            emitCodes.push(code);
            emitNames.push(saved.names[idx] || "");
          });
        }
      });

      if (!emitCodes.length) {
        this.$tool.PromptBox("warning", "精确到市级");
        return;
      }

      this.$emit(
        "handleUnderstand",
        emitNames.filter(Boolean).join("、"),
        emitCodes
      );
    },
  },
};
</script>

<style scoped lang="less">
// 标题
.title {
  width: 100%;
  min-height: 90px;
  position: relative;
  display: flex;
  // 关闭按钮
  .Off-icon {
    width: 18px;
    height: 18px;
    background-image: url("../../../../../assets/imgs/guanbi.svg");
    background-size: 100% 100%;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .Text-title {
    height: 20px;
    width: 100px;
    line-height: 20px;
    margin: auto 0;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    font-weight: 400;
    margin-left: 30px;
  }

  // 搜索框
  .input-box {
    width: 340px;
    height: 30px;
    line-height: 30px;
    margin: auto 0;
    margin-left: 70px;
    display: flex;
    position: relative;

    // input框的样式
    /deep/.el-input__inner {
      width: 250px;
      font-size: 16px;
      line-height: 30px;
      height: 30px !important;
      border: 1px solid #409eff ;
      background: #ffffff;
      // position: absolute;
      border-radius: 10px;
      z-index: 1;
    }
    // 搜索按钮样式
    .search_btn {
      font-size: 16px;
      color: #ffffff;
      font-weight: 400;
      line-height: 30px;
      background-color: #409eff ;
      width: 100px;
      height: 30px;
      border-radius: 0px 10px 10px 0px;
      cursor: pointer;
      position: absolute;
      right: 0;
      display: flex;
      white-space: nowrap;
      div {
        width: 60px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        display: flex;
        p {
          width: 20px;
          height: 20px;
          font-size: 18px;
        }
      }
    }
  }
}
.nationwide-quick__btn {
  display: inline-block;
  padding: 4px 16px;
  font-size: 14px;
  color: #409eff ;
  cursor: pointer;
  border: 1px solid #409eff ;
  border-radius: 6px;
  user-select: none;
}
.nationwide-quick__btn--active {
  background: #409eff ;
  color: #ffffff;
}
.title-nationwide {
  margin: auto 0;
  margin-left: 16px;
}
// 内容主体
.main-body {
  width: 100%;
  height: 450px;
  display: flex;
  border-bottom: 1px dashed #409eff ;
  .left-menu::-webkit-scrollbar {
    display: none;
  }
  .left-menu {
    width: 175px;
    height: 100%;
    margin-left: 5px;
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    div {
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      margin-bottom: 10px;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 10px 0px 0px 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
    }
    .left-menu-has-selected {
      color: #409eff ;
    }
    .left-menu-Select {
      background: #eeeeee;
      color: #409eff ;
    }
  }
  .right-Options::-webkit-scrollbar {
    display: none;
  }
  .right-Options {
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    flex: 1;
    height: 100%;
    background: #eeeeee;
    // 市级 div
    .MunicipalLevel-box {
      //   width: 100%;
      //   height: 237px;
      border-bottom: 1px dashed #409eff ;
      margin: 20px 20px 0px 20px;
      display: flex;
      flex-wrap: wrap;
      p {
        min-width: 85px;
        padding-left: 8px;
        padding-right: 8px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 5px;
        margin-right: 18px;
        margin-bottom: 18px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      cursor: pointer;
    }
      .TheCitySelect {
        background: #409eff ;
        border: 1px solid #409eff ;
        color: #ffffff;
      }
    }
    // 区 县级
    .area-box {
      //   width: 100%;
      //   height: 237px;
      margin: 0px 20px 0px 20px;
      display: flex;
      flex-wrap: wrap;
      p {
        min-width: 85px;
        padding-left: 8px;
        padding-right: 8px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 5px;
        margin-right: 20px;
        margin-top: 20px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
      .TheCitySelect {
        background: #409eff ;
        border: 1px solid #409eff ;
        color: #ffffff;
      }
    }
  }
}
// 调整对话框
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
